export default {"src":"/_next/static/media/nuintrox.e75c93d1.PNG","height":949,"width":1920,"blurWidth":0,"blurHeight":0};